/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: '크게',
	['预设']: '기본값 /',
	['较小']: '작게',
	['字级大小']: '글자 크기',
	['页面正在加载中']: '페이지 로딩 중...',
	['这可能需要几分钟的时间，请耐心等待']: '분 정도 소요될 수 있습니다. 잠시만 기다려 주세요',
	['您所访问的页面不存在']: '요청하신 페이지를 찾을 수 없습니다',
	['开始对话']: '대화 시작',
	['充值未到帐快速通道']: '충전 미반영 문의',
	['人工客服']: '인공지능 고객 서비스',
	['已接听']: '연결됨',
	['结束对话']: '대화 종료',
	['联络人工客服']: '상담원 연결',
	['重新选择智能客服']: '스마트 상담원 다시 선택',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: '이용해 주셔서 감사합니다. 설문 조사에 참여해 주세요...',
	['您觉得此次的服务品质如何？']: '이번 상담 서비스에 만족하셨나요?',
	['颗星']: '별점',
	['颗星(單數)']: '별점',
	['不评分']: '평가하지 않음',
	['点选下方即可结束对话']: '아래를 선택하여 대화 종료',
	['请输入您的ID']: 'ID를 입력해 주세요',
	['ID不能为空']: 'ID는 비어 있을 수 없습니다.',
	['说明文字']: '설명 문구',
	['送出']: '전송',
	['系统维护中']: '시스템 점검 중',
	['储存']: '저장',
	['确认']: '확인',
	['取消']: '취소',
	['完成']: '완료',
	['协作']: '협력',
	['转接']: '전환',
	['离开']: '나가기',
	['请选择服务对象开始通话']: '통화할 상대를 선택해 주세요',
	['请填写表单']: '양식을 작성해 주세요',
	['本对话已经结束']: '이 대화는 종료되었습니다.',
	['客服已逾 {{second}} 秒未回应']: '고객 서비스가 {{second}} 초 동안 응답하지 않았습니다.',
	['历史对话']: '역사 대화',
	['查无资料']: '자료 없음',
	['标签']: '태그',
	['正在输入中...']: '입력 중입니다...',
	['于']: '이모든',
	['档案容量限制']: '파일 용량 제한',
	['不能为空']: '비어 있을 수 없습니다',
	['提交']: '제출',
	['满意度']: '만족도',
	['IP未知']: 'IP 미확인',
	['地区未知']: '지역 미상',
	['使用者环境未知']: '사용자 환경 미지수',
	['关闭']: '닫기',
	['全萤幕截图成档案']: '전체 화면 캡처 및 파일 저장',
	['Mac用户']: 'Mac 사용자',
	['Windows用户']: 'Windows 사용자',
	['Windows键']: 'Windows 키',
	['全萤幕截图至剪贴簿']: '전체 화면 캡처 및 복사',
	['截图完成后请直接于文字输入处贴上']: '캡처 후 입력창에 붙여넣어 주세요',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: '캡처 도구 등을 사용하여 스크린샷을 찍은 후 붙여넣어 주세요',
	['截图']: '스크린샷',
	['档案']: '파일',
	['下载失败']: '다운로드 실패',
	['请输入分类名称']: '분류 이름을 입력하세요',
	['新增']: '추가',
	['更新']: '업데이트',
	['请选择一个分类']: '분류를 선택하세요',
	['请输入标题']: '제목을 입력하세요',
	['请输入内文']: '내 내용을 입력하세요.',
	['请上传图片']: '이미지를 업로드 해주세요',
	['快捷语']: '단축어',
	['图片']: '이미지',
	['管理分类']: '관리 분류',
	['新增分类']: '새로운 분류 추가',
	['标题/内文']: '제목/내용',
	['分类']: '분류',
	['编辑']: '편집',
	['删除']: '삭제',
	['平台名称']: '플랫폼 이름',
	['显示']: '표시',
	['编辑服务平台']: '편집 서비스 플랫폼',
	['若有服务中的客户，无法关闭服务平台']: '서비스 중인 고객이 있을 경우, 서비스 플랫폼을 닫을 수 없습니다.',
	['确定']: '확인',
	['人员列表']: '인원 목록',
	['服务人数']: '서비스 인원',
	['选择转接人员']: '전환 담당자 선택',
	['按此上传图片']: '이미지 업로드 클릭',
	['确定要取消{{displayName}}协作邀请吗？']: '정말로 {{displayName}} 협업 초대를 취소하시겠습니까?',
	['确定要结束{{displayName}}的协作吗？']: '{{displayName}}와의 협업을 종료하시겠습니까?',
	['等待协作中']: '협업 중입니다.',
	['协作中']: '협력 중',
	['负责人']: '책임자',
	['已选择']: '선택됨',
	['可协作人数已满']: '협력 가능한 인원이 가득 차 있습니다.',
	['选择协作人员']: '협력자 선택',
	['提示']: '알림',
	['请输入讯息']: '메시지를 입력해 주세요',
	['确定已經完成？']: '완료했습니까?',
	['常用图片']: '자주 사용하는 이미지',
	['用户']: '사용자',
	['个人']: '개인',
	['公共']: '공공',
	['开始谈话']: '대화 시작',
	['等待中']: '대기 중',
	['客户已离开对话']: '고객이 대화를 종료했습니다.',
	['正在转接给']: '전환 중입니다.',
	['邀请你加入协作']: '협업에 참여하라고 초대합니다',
	['请求转接']: '요청 전환',
	['正在服务中']: '서비스 중',
	['编辑平台']: '편집 플랫폼',
	['您的连线已中断']: '귀하의 연결이 끊어졌습니다.',
	['正尝试重新连线']: '정상적으로 재연결 시도 중',
	['重新登入']: '재로그인',
	['请先登入']: '먼저 로그인 해주세요',
	['帐号']: '계정',
	['帐号不能为空']: '계정은 비워둘 수 없습니다',
	['请输入帐号']: '계정을 입력하세요',
	['密码']: '비밀번호',
	['密码不能为空']: '비밀번호는 비어 있을 수 없습니다',
	['请输入密码']: '비밀번호를 입력하세요',
	['登录']: '로그인',
	['客服系统客服端']: '고객 서비스 시스템 고객 단말',
	['平台异动，请重新整理']: '플랫폼 이상 발생, 새로 고침 해주세요',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: '고객 서비스 시스템 업그레이드 유지 보수 중입니다. 나중에 온라인 고객 서비스에 다시 연락해 주시기 바랍니다. 감사합니다.',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: '고객 서비스 시스템이 업그레이드 유지 보수를 위해 작동 중단되었습니다. 대화를 중단하게 되어 죄송합니다. 나중에 온라인 고객 서비스에 다시 연락해 주시기 바랍니다.',
	['请稍后再试']: '잠시 후 다시 시도해 주세요',
	['是']: '네',
	['否']: '아니요',
	['等于']: '같은',
	['包含']: '포함',
	['排除']: '제외',
	['大于']: '보다',
	['少于']: '적은',
	['数量区间']: '수량 범위',
	['客服对话数']: '고객 서비스 대화 수',
	['客戶对话数']: '고객 대화 수',
	['即时资讯']: '즉시 뉴스',
	['报表分析']: '보고서 분석',
	['平均通话时间']: '평균 통화 시간',
	['回覆通话数']: '회신 통화 수',
	['平均等待时间']: '평균 대기 시간',
	['客户满意度']: '고객 만족도',
	['历史对话记录']: '역사 대화 기록',
	['操作日志']: '작업 로그',
	['智能客服设定']: '스마트 고객 서비스 설정',
	['机器人设定']: '로봇 설정',
	['版本管理']: '버전 관리',
	['档案总览']: '파일 개요',
	['设定']: '설정',
	['公司管理']: '회사 관리',
	['维修管理']: '유지 관리',
	['一般设定']: '일반 설정',
	['公告管理']: '공지 관리',
	['帐号管理']: '계정 관리',
	['平台管理']: '플랫폼 관리',
	['角色管理']: '캐릭터 관리',
	['团队管理']: '팀 관리',
	['标签管理']: '태그 관리',
	['查询']: '조회',
	['重置']: '재설정',
	['今天']: '오늘',
	['昨天']: '어제',
	['过去7天']: '지난 7일',
	['过去10天']: '지난 10일',
	['过去一个月']: '지난 한 달',
	['过去90天']: '지난 90일',
	['LOGO 预览']: 'LOGO 미리보기',
	['档案格式：PNG、JPG，长宽不超过']: '파일 형식: PNG, JPG, 가로 세로 초과하지 않음',
	['档案太大或格式不支援']: '파일이 너무 크거나 형식이 지원되지 않습니다',
	['且档案大小不得大于']: '및 파일 크기는 {0}보다 커서는 안 됩니다',
	['上传档案']: '파일 업로드',
	['新增IP白名单成功']: 'IP 화이트리스트 추가 성공',
	['删除IP白名单成功']: 'IP 화이트리스트 삭제 성공',
	['请输入欲查询的IP']: '입력할 IP를 입력하세요',
	['请输入IP']: 'IP를 입력하세요',
	['备注']: '비고',
	['备注不能为空']: '비고는 비워둘 수 없습니다.',
	['请输入备注']: '비고를 입력하세요',
	['新增时间']: '추가 시간',
	['操作']: '조작',
	['IP白名单']: 'IP 화이트 리스팅',
	['新增IP']: '새로운 IP',
	['新增IP白名单']: 'IP 화이트리스트 추가',
	['确定删除此IP?']: '이 IP를 삭제하시겠습니까?',
	['平台']: '플랫폼',
	['团队']: '팀',
	['全体']: '전체',
	['客服']: '고객 서비스',
	['客服系统']: '고객 서비스 시스템',
	['个人帐号设定']: '개인 계정 설정',
	['最少6码']: '최소 6자리',
	['最多20码']: '최대 20야드',
	['不能有空白']: '빈 공간이 없어야 한다',
	['应至少包含1个英文和数字']: '영어와 숫자를 각각 1개 이상 포함해야 합니다.',
	['公司名称']: '회사 이름',
	['僅能输入英文和数字']: '영어와 숫자만 입력할 수 있습니다.',
	['应至少包含1个英文']: '영어를 최소한 1개 포함해야 합니다.',
	['最少5码']: '최소 5자리',
	['IP不能为空']: 'IP는 비워둘 수 없습니다.',
	['非IP位址']: '비IP주소',
	['最多500个字']: '최대 500자',
	['启用']: '활성화',
	['禁用']: '금지',
	['对话量']: '대화량',
	['目前客户数']: '현재 고객 수',
	['目前客服数']: '현재 고객 서비스 수',
	['接通对话量']: '통화량',
	['全部']: '전체',
	['最近一天']: '최근 하루',
	['最近一周']: '최근 일주일',
	['最近一月']: '최근 한 달',
	['新增过滤器']: '필터 추가',
	['请输入模組名称']: '모듈 이름을 입력하세요',
	['储存过滤模組']: '저장 필터 모듈',
	['读取过滤模組']: '읽기 필터 모듈',
	['确定要删除模組']: '모듈을 삭제하시겠습니까?',
	['分钟']: '분간',
	['接通时间']: '연결 시간',
	['通话时间']: '통화 시간',
	['请选择或输入时间']: '시간을 선택하거나 입력하세요',
	['等待时间']: '대기 시간',
	['对话搜寻']: '대화 검색',
	['请输入对话']: '대화를 입력하세요',
	['客戶 ID']: '고객 ID',
	['请输入客戶ID']: '고객 ID를 입력하세요',
	['对话浏览模式']: '대화 탐색 모드',
	['筆']: '필기구',
	['客服本名']: '고객 서비스 본명',
	['进入时间']: '입장 시간',
	['客服昵称']: '고객 서비스 닉네임',
	['客服系统管理端']: '고객 서비스 시스템 관리端',
	['数量']: '수량',
	['尚未上传档案']: '파일이 아직 업로드되지 않았습니다.',
	['输入文字']: '입력 문자',
	['请在此输入文字']: '여기에 텍스트를 입력하세요',
	['添加项目']: '항목 추가',
	['请选择']: '선택하세요',
	['新增文字']: '새 텍스트 추가',
	['新增档案']: '새 파일',
	['選項']: '옵션',
	['勾选标题']: '제목 선택',
	['文字內容不能为空']: '문자 내용이 비어 있을 수 없습니다',
	['添加']: '추가',
	['上传标题']: '업로드 제목',
	['单选标题']: '단일 선택 제목',
	['输入框标题']: '입력 상자 제목',
	['请输入']: '입력해 주세요',
	['输入框']: '입력 상자',
	['单选']: '단일 선택',
	['核取方块']: '확인란',
	['请选择一个标签']: '태그를 선택하세요',
	['确定要删除此项目和其所有子项目？']: '이 항목과 그 모든 하위 항목을 삭제하시겠습니까?',
	['答案']: '답변',
	['表单']: '양식',
	['清除此阶层设定']: '이 계층 설정 지우기',
	['请输入此阶层问题']: '이 계층 문제를 입력하세요',
	['新增选项']: '새로운 옵션 추가',
	['新增表单']: '신규 양식 추가',
	['新增答案']: '답변 추가',
	['新增充值表单']: '충전 양식 추가',
	['若切换种类后, 将清除原有的和其子项目资料']: '종류를 변경하면 기존 자료 및 해당 하위 항목의 정보가 삭제됩니다.',
	['确定要清除所有资料和其子项目资料？']: '모든 자료와 해당 하위 항목의 자료를 정말로 삭제하시겠습니까?',
	['阶层']: '계층',
	['开场语']: '개회사',
	['开场语不能为空']: '시작 발언은 비워둘 수 없습니다.',
	['结尾感谢语']: '마무리 감사 인사',
	['结尾感谢语不能为空']: '결말 감사 문구는 비워둘 수 없습니다',
	['发布']: '발행',
	['复制']: '복사',
	['选择目的平台']: '목표 플랫폼 선택',
	['确定复制到']: '확인 복사하기',
	['是否要正式发布到使用环境？']: '사용 환경에 공식 발표할까요?',
	['储存版本']: '저장 버전',
	['版本名称']: '버전 이름',
	['请输入版本名称']: '버전 이름을 입력하세요',
	['确定是否储存此版本']: '이 버전을 저장할지 확인하세요',
	['版本储存成功']: '버전 저장 성공',
	['最多10个字']: '최대 10자',
	['公告一']: '공지사항 1',
	['公告二']: '공지 사항 2',
	['公告三']: '공지사항 삼',
	['公告储存成功']: '공지 저장 성공',
	['标题']: '제목',
	['內文']: '내부 내용',
	['修改登入密码']: '로그인 비밀번호 변경',
	['修改基本资讯']: '기본 정보 수정',
	['昵称']: '닉네임',
	['昵称不能为空']: '닉네임은 비워둘 수 없습니다.',
	['请输入昵称']: '닉네임을 입력하세요',
	['本名']: '본명',
	['本名不能为空']: '본명은 비워둘 수 없습니다',
	['请输入本名']: '본명을 입력하세요',
	['选择图像']: '이미지 선택',
	['状态']: '상태',
	['平台代码']: '플랫폼 코드',
	['平台代码不能为空']: '플랫폼 코드는 비워둘 수 없습니다',
	['使用ID模式登入']: 'ID 모드로 로그인',
	['新增平台']: '새 플랫폼',
	['修改平台']: '수정 플랫폼',
	['确定重新产生Key/IV?']: '키/IV를 다시 생성하시겠습니까?',
	['进入公司成功']: '회사를 성공적으로 들어가다',
	['确定禁用公司?']: '회사를 비활성화하시겠습니까?',
	['确定启用公司?']: '회사를 활성화하시겠습니까?',
	['修改公司']: '회사 수정',
	['进入公司']: '회사에 들어가다',
	['确定进入公司?']: '확인 회사에 들어가기?',
	['新增标签']: '새 태그 추가',
	['代号']: '암호',
	['代号不可为空']: '코드는 비워둘 수 없습니다',
	['名称']: '이름',
	['名称不可为空']: '이름은 비워둘 수 없습니다.',
	['颜色']: '색깔',
	['颜色不可为空']: '색깔은 비어 있을 수 없습니다',
	['进入标签']: '탭으로 들어가기',
	['修改标签']: '수정 태그',
	['确定开启进入标签?']: '확인하고 탭을 열까요?',
	['确定关闭进入标签?']: '확실히 탭을 닫겠습니까?',
	['确定删除此标签?']: '이 태그를 삭제하시겠습니까?',
	['标签创建成功']: '태그 생성 성공',
	['标签更新成功']: '태그 업데이트 성공',
	['进入标签更新成功']: '태그 업데이트가 성공적으로 진행되었습니다.',
	['标签删除成功']: '태그 삭제 성공',
	['请输入代号、名称等关键字']: '코드, 이름 등의 키워드를 입력하세요.',
	['设定开场白成功']: '시작 인사 설정 성공',
	['客戶进入开场白']: '고객의 오프닝',
	['客戶进入开场白不可为空']: '고객의 소개는 비워둘 수 없습니다.',
	['第一次通知时间']: '첫 번째 알림 시간',
	['第{{count}}次通知时间']: '제{{count}}차 알림 시간',
	['设置错误']: '설정 오류',
	['设定等待过长通知时间成功']: '대기 시간이 너무 길게 설정되었습니다.',
	['秒']: '초',
	['对话自动断开时间']: '대화 자동 종료 시간',
	['未发话时间']: '말하지 않은 시간',
	['未发话提示文字']: '미발화提示文字',
	['设定对话断开成功']: '대화 분리가 성공적으로 설정되었습니다.',
	['Favicon预览']: '파비콘 미리보기',
	['更换 Favicon 成功']: '파비콘 변경 성공',
	['档案格式：ICO，長寬不超過 32x32 px']: '파일 형식: ICO, 가로 세로 32x32 px를 초과하지 않아야 합니다.',
	['更换 LOGO 成功']: '로고 변경 성공',
	['智能客服']: '스마트 상담',
	['设定通道成功']: '채널 설정 성공',
	['设定提示音效成功']: '알림음 효과 설정 성공',
	['单音']: '단음',
	['循环音']: '순환음',
	['编号']: '번호',
	['资料类型']: '자료 유형',
	['资料类型不可为空']: '자료 유형은 비워둘 수 없습니다.',
	['数字']: '숫자',
	['字串']: '문자열',
	['布林']: '브린',
	['建立标签成功']: '태그 생성 성공',
	['修改标签成功']: '레이블 수정 성공',
	['删除标签成功']: '태그 삭제 성공',
	['更换 LOGO']: '로고 변경',
	['更换 Favicon']: '파비콘 변경',
	['对话断开']: '대화가 끊겼습니다',
	['等待过长通知时间']: '긴 대기 통지 시간',
	['开场白']: '운영 발언',
	['提示音效设定']: '알림음 설정',
	['通道设定']: '통로 설정',
	['自定义标签']: '사용자 정의 태그',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: '수리 모드를 활성화하면 고객 서비스 시스템의 운영이 중지됩니다. 정말로 활성화하시겠습니까?',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: '수리 모드를 종료하면 고객 서비스 시스템이 계속 작동합니다. 정말 종료하시겠습니까?',
	['状态更新成功']: '상태 업데이트 성공',
	['通知讯息更新成功']: '알림 메시지 업데이트 성공',
	['维修模式']: '수리 모드',
	['通知讯息设定']: '알림 메시지 설정',
	['尚未连线状态']: '연결되지 않은 상태',
	['尚未连线状态描述']: '연결되지 않은 상태 설명',
	['已连线状态']: '연결된 상태',
	['已连线状态描述']: '연결된 상태 설명',
	['开启成功']: '성공적으로 열다',
	['关闭成功']: '닫힘 성공',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: '로그인 관리 모드를 종료하면 고객이 ID를 입력하여 고객 서비스에 접속하는 것이 제한됩니다. 종료할 것인가요? (고객 프로필 정보가 제공되지 않으면 오류 페이지로 이동합니다.)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: '로그인 관리 모드를 활성화하면 고객이 ID를 입력하여 고객 서비스에 접근할 수 있습니다. 정말로 활성화하시겠습니까?',
	['请输入帐号、昵称、角色等关键字']: '계정, 닉네임, 역할 등의 키워드를 입력하세요',
	['新增角色']: '신규 캐릭터',
	['修改角色']: '캐릭터 수정',
	['角色创建成功']: '캐릭터 생성 성공',
	['角色更新成功']: '캐릭터 업데이트 성공',
	['角色删除成功']: '캐릭터 삭제 성공',
	['请输入角色名称，平台，权限等关键字']: '문자열 이름, 플랫폼, 권한 등의 키워드를 입력하세요.',
	['关键字']: '키워드',
	['角色名称']: '캐릭터 이름',
	['角色名称不可为空']: '캐릭터 이름은 비워둘 수 없습니다。',
	['请输入角色名称']: '캐릭터 이름을 입력하세요',
	['上级角色']: '상위 역할',
	['上级角色不可为空']: '상위 역할은 비워둘 수 없습니다.',
	['权限']: '권한',
	['确定删除此角色?']: '이 캐릭터를 삭제하시겠습니까?',
	['图像不能为空']: '이미지는 비워둘 수 없습니다.',
	['新增团队']: '팀 추가',
	['修改团队']: '수정팀',
	['团队创建成功']: '팀 생성 성공',
	['团队修改成功']: '팀 수정 성공',
	['团队删除成功']: '팀 삭제 성공',
	['人数']: '인원',
	['新登入密码']: '새 로그인 비밀번호',
	['新密码不能设定與舊密码相同']: '새 비밀번호는 이전 비밀번호와 같을 수 없습니다.',
	['新密码與確認密码不相同']: '새 비밀번호와 확인 비밀번호가 다릅니다.',
	['确定修改登入密码?']: '로그인 비밀번호를 수정하시겠습니까?',
	['登入密码修改成功，请重新登入']: '로그인 비밀번호가 성공적으로 변경되었습니다. 다시 로그인해 주세요.',
	['个人资讯']: '개인 정보',
	['搜寻快捷语']: '검색 단축어',
	['登出']: '로그아웃',
	['帐密错误']: '계정 비밀번호 오류',
	['一']: '일',
	['二']: '이',
	['三']: '삼',
	['四']: '넷',
	['五']: '오',
	['六']: '육',
	['七']: '칠',
	['请输入客服本名、客服昵称等关键字']: '고객 서비스 본명, 고객 서비스 닉네임 등의 키워드를 입력하세요',
	['共 {{count}} 筆资料']: '총 {{count}} 건의 자료',
	['平台语言不能为空']: '플랫폼 언어는 비어 있을 수 없습니다',
	['开启']: '열기',
	['语言']: '언어',
	['切换语言']: '언어 전환',
	['语言名称']: '언어 이름',
	['系统设定']: '시스템 설정',
	['储存成功']: '저장 성공',
	['发布成功']: '게시 성공',
	['复制成功']: '복사 성공',
	['项目选取']: '프로젝트 선택',
	['图像']: '이미지',
	['角色']: '캐릭터',
	['新增帐号']: '계정 추가',
	['角色不能为空']: '캐릭터는 비워둘 수 없습니다.',
	['登入密码']: '로그인 비밀번호',
	['请输入代号、名称、备注等关键字']: '코드, 이름, 비고 등의 키워드를 입력해주세요',
	['确定删除此团队?']: '이 팀을 삭제하시겠습니까?',
	['切换语言成功']: '언어 변경 완료',
	['确定要切换语言?']: '언어를 변경하시겠습니까?',
	['选项']: '옵션',
	['选择语言']: '언어 선택',
	['修改成功']: '수정 성공',
	['舊登入密码']: '구 로그인 비밀번호',
	['確認新登入密码']: '새 로그인 비밀번호 확인',
	['语言切换成功，將重整页面以套用更新']: '언어 전환 성공, 페이지를 새로 고쳐 업데이트를 적용합니다.',
	['笔 / 页']: '펜 / 페이지',
	['时段搜寻']: '시간대 검색',
	['请选择时段']: '시간대를 선택하십시오',
	['更换背景色']: '배경색 변경',
	['设定背景颜色成功']: '배경색 설정 성공',
	['请重新登入']: '다시 로그인 해주세요',
	['绑定谷歌验证']: '구글 인증기 연결',
	['解除绑定']: '해제',
	['谷歌验证状态']: '구글 인증 상태',
	['已绑定']: '바인딩됨',
	['未绑定']: '미결정',
	['解绑谷歌验证失败']: 'Google 인증 바인딩 해제에 실패했습니다',
	['二维码方式添加']: 'QR 코드 방식 추가',
	['请在 Google 身份验证器中采用添加条形码方式添加']: 'Google 인증 앱에서 바코드 추가 방법으로 추가해 주세요.',
	['密钥方式添加']: '키 방식 추가',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: 'Google 인증기에서 제공된 키를 입력하여 추가해 주세요.',
	['密钥如下所示']: '키는 다음과 같습니다.',
	['请再次输入登入密码']: '다시 로그인 비밀번호를 입력해 주세요.',
	['谷歌6位动态密码']: '구글 6자리 동적 비밀번호',
	['请绑定谷歌验证']: '구글 인증을 연결해 주세요.',
	['谷歌验证绑定成功']: '구글 인증 연결 성공',
	['解绑谷歌验证成功']: '구글 인증 해제 성공',
	['确定解绑谷歌验证？']: '구글 인증 해제하시겠습니까?',
	['请输入谷歌动态码']: '구글 동적 코드를 입력하세요',
	['谷歌动态码']: '구글 동적 코드',
	['谷歌动态码不能为空']: '구글 동적 코드에는 비워둘 수 없습니다',
	['谷歌动态码长度6码']: '구글 동적 코드 길이 6자리',
	['谷歌动态码错误']: '구글 동적 코드 오류',
	['內容']: '내용',
	['搜寻']: '검색',
	['连线中断，点击“确定”即重新连线客服。']: '연결이 끊어졌습니다. "확인"을 클릭하면 고객 서비스에 다시 연결됩니다.',
	['充值表单']: '충전 양식',
	['网银充值']: '인터넷 뱅킹 충전',
	['扫码充值']: 'QR코드 충전',
	['带入目前帐号']: '현재 계정으로 로그인',
	['自行输入平台帐号']: '플랫폼 계정을 직접 입력하세요',
	['充值方式']: '충전 방식',
	['平台帐号']: '플랫폼 계정',
	['充值金额']: '충전 금액',
	['付款人姓名']: '입금자명',
	['确认语']: '확인어',
	['操作时间']: '작업 시간',
	['操作者']: '조작자',
	['请输入备注等关键字']: '메모 등 핵심 키워드를 입력하세요',
	['操作类型']: '작업 유형',
	['修改平台昵称']: '플랫폼 닉네임 수정',
	['修改平台昵称成功']: '플랫폼 닉네임 수정 성공',
	['输入格式错误']: '입력 형식 오류',
	['套用']: '적용',
	['确定套用到']: '확인하여 적용하다',
	['套用成功']: '적용 성공',
	['储存方式']: '저장 방법',
	['储存時間']: '저장 시간',
	['系统发布']: '시스템 출시',
	['手动储存']: '수동 저장',
	['自动储存']: '자동 저장',
	['预览']: '미리보기',
	['最多350个字']: '최대 350자',
	['修改']: '수정',
	['共同资讯管理']: '공동 정보 관리',
	['共同资讯创建成功']: '공동 정보 생성 성공',
	['共同资讯修改成功']: '공통 정보 수정 성공',
	['新增共同资讯']: '공동 정보 추가',
	['修改共同资讯']: '공동 정보 수정',
	['删除成功']: '삭제 성공',
	['已设置于其他答案，无法删除']: '다른 답변에 설정되어 있어 삭제할 수 없습니다.',
	['请输入名称、内容等关键字']: '이름, 내용 등의 키워드를 입력하세요',
	['确定删除此共同资讯？']: '이 공동 정보를 삭제하시겠습니까?',
	['共同资讯']: '공동 정보',
	['尚未选择共同资讯']: '아직 공동 정보를 선택하지 않음',
	['选择共同资讯']: '공동 정보 선택',
	['选择']: '선택',
	['点击「确定」后，即覆盖该平台的快捷语设定']: '\'확인\'을 클릭하면 해당 플랫폼의 단축어 설정이 덮어씌워집니다.',
	['已复制：目的平台']: '목적 플랫폼',
	['是否离开客服系统？']: '고객센터를 나가시겠습니까',
	['感谢您的作答，此次评分为：{{score}}分']: '답변 감사합니다. 이번 평점: {{score}}점.',
	['共 {{count}} 筆']: '총 {{count}} 건',
	['分']: '분',
	['新增公司']: '회사 추가',
	['翻译']: '번역',
	['显示原文']: '원문 보기',
	['解绑谷歌验证']: '구글 인증 해제',
	['请输入名称 内容等关键字']: '이름을 입력하세요 주요 키워드',
	['表单选项']: '폼 옵션',
	['年']: '년',
	['等待时间颜色设定']: '기다리는 시간 색상 설정',
	['显示颜色']: '색상 표시',
	['确认删除此规则?']: '이 규칙을 삭제하시겠습니까?',
	['页签']: '탭',
	['超过 {{time}} 分钟']: '초과 {{time}} 분',
	['新增成功']: '추가 성공',
	['删除完成']: '삭제 완료',
	['等待时间(分钟)']: '대기 시간(분)',
	['时间']: '시간',
	['不可为空']: '비워 둘 수 없습니다',
	['需为正整数']: '양의 정수여야 합니다',
	['按平台名称排列(A-Z)']: '플랫폼 이름별 정렬(A-Z)',
	['按平台名称排列(Z-A)']: '플랫폼 이름으로 정렬 (Z-A)',
	['旧版面模式']: '구형 인터페이스 모드',
	['自动翻译']: '자동 번역',
	['功能設定']: '기능 설정',
	['确认切换版面？']: '편집 모드로 전환하시겠습니까?',
	['确认开启自动翻译？']: '자동 번역을 활성화하시겠습니까?',
	['确认关闭自动翻译？']: '자동 번역을 끄시겠습니까?',
	['原文']: '원문',
	['泰语']: '태국어',
	['追踪']: '추적',
	['取消追踪']: '언팔로우',
	['预览影片']: '미리보기 영상',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: '오직 MP4, MOV, JPEG (JPG), PNG, GIF, HEIC, RAW, HEIF 파일만 업로드할 수 있습니다.',
	['请勿输入语法相关字串']: '코드나 구문 관련 문자열은 입력하지 마세요',
	['输入名称']: '입력 이름',
	['设为预设版本']: '기본 버전으로 설정',
	['另存为新版本']: '새 버전으로 저장',
	['请选择版本']: '버전을 선택하세요',
	['一键开关']: '원터치 스위치',
	['若有服务中的客户，无法关闭服务平台与切换版本']: '서비스 중인 고객이 있는 경우, 서비스 플랫폼을 종료하거나 버전을 전환할 수 없습니다.',
	['是否确认要覆盖已有的设定，储存新的设定？']: '기존 설정을 덮어쓰고 새 설정을 저장할 것인지 확인하시겠습니까?',
	['已储存超过五个版本']: '다섯 개 이상의 버전이 저장되었습니다.',
	['版本已变动，是否需要储存？']: '버전이 변경되었습니다. 저장하시겠습니까?',
	['确定删除此版本？']: '이 버전을 삭제하시겠습니까?',
	['编辑版本']: '편집 버전',
	['侦测到重复联系客服系统，若非您本人请告知客服']: '중복 접속이 감지되었습니다. 본인이 아니면 알려주세요',
	['删除此版本']: '이 버전 삭제',
	['刪除成功']: '삭제 성공',
	['刪除失敗']: '삭제 실패',
	['儲存成功']: '저장 완료',
	['儲存失敗']: '저장 실패',
	['您好，请问要选择哪个问题？']: '안녕하세요, 어떤 도움이 필요하신가요?',
	['等待服务区']: '대기 서비스 구역',
	['按时间排列(長到短)']: '시간순으로 정렬(길이순)',
	['按时间排列(短到長)']: '시간 순으로 정렬(짧은 것부터 긴 것까지)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: '고객님, 환영합니다! 정성을 다해 도와드리겠습니다. 잠시만 기다려 주시면 곧바로 안내해 드리겠습니다.',
	['编辑标签']: '편집 태그',
	['于 {{time}} 侦测到会员【稍早已离线】']: '{{time}}에 회원【조금 전에 오프라인】이 감지되었습니다.',
	['{{score}}分']: '{{score}}점',
	['未评分']: '미평가',
	['客服完成']: '고객 서비스 완료',
	['会员离线']: '회원 오프라인',
	['超时自动断线']: '초과 시간 자동 연결 종료',
	['{{text}}不可重复']: '{{text}}는 중복될 수 없습니다.',
	['{{text}}不能为空']: '{{text}}는 비워둘 수 없습니다.',
	['{{text}}设置错误']: '{{text}} 설정 오류',
	['平均通话时长']: '평균 통화 시간',
	['平均通话数']: '평균 통화 수',
	['请选择角色名称']: '캐릭터 이름을 선택하세요',
	['请选择客服']: '고객 서비스 선택하세요',
	['请选择团队']: '팀을 선택하세요',
	['播放']: '재생',
	['统计时间']: '통계 시간',
	['统计时间不可为空']: '통계 시간은 비워둘 수 없습니다.',
	['请输入时间']: '시간을 입력하세요',
	['时间筛选']: '시간 필터',
	['汇出']: '수출',
	['未出勤']: '미출석',
	['客服平均通话时长']: '고객 서비스 평균 통화 시간',
	['数量筛选']: '수량 필터',
	['客服平均等待时间']: '고객 서비스 평균 대기시간',
	['上一个月']: '지난달',
	['导出Excel成功']: '엑셀 내보내기 성공',
	['对话结束']: '대화 종료',
	['满意度/客服']: '만족도/고객 서비스',
	['日期/客服']: '날짜/고객 서비스',
	['总数']: '총수',
	['日平均']: '일일 평균',
	['客服日均量']: '고객 서비스 일일 건수',
	['客服通话总量']: '고객 서비스 통화 총량',
	['日总量']: '일일 총량',
	['请输入数量']: '수량을 입력하세요',
	['满意度预设分数']: '만족도 기본 점수',
	['当会员未评分，会自动给予此预设分数。']: '회원이 평가하지 않을 경우, 이 기본 점수가 자동으로 부여됩니다.',
	['设定满意度预设分数成功']: '만족도 설정 점수 성공',
	['客户满意度管理']: '고객 만족도 관리',
	['对话结束方式']: '대화 종료 방식',
	['对话满意度']: '대화 만족도',
	['时段']: '시간대',
	['客服平均满意度']: '고객 서비스 평균 만족도',
	['公用设定']: '공용 설정',
	['通话时长']: '통화 시간',
	['服务时段']: '서비스 시간',
	['储存时间']: '저장 시간',
	['客服不可为空']: '고객 서비스는 비워둘 수 없습니다.',
	['团队不可为空']: '팀은 비어있을 수 없습니다',
	['请输入对话内容关键字']: '대화 내용 키워드를 입력하세요',
	['请输入客服本名、昵称或帐号']: '고객 서비스 본명, 별명 또는 계정을 입력하세요',
	['平台不可为空']: '플랫폼은 비워둘 수 없습니다.',
	['线上']: '온라인',
	['离线']: '오프라인',
	['日期不可为空']: '날짜는 비어 있을 수 없습니다.',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: '친애하는 분, 다시 확인하고자 합니다. 이번 충전 {{chargeNumber}} 원을 신청하고 진행한 계정은 {{chargeAccount}} 맞습니까?',
	['您的等待顺位为第 {{pendingOrder}} 位']: '현재 대기 순번은 {{pendingOrder}} 번째입니다.',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: '{{inviter}}가 {{invitee}}에게 전환하는 것을 거부합니다.',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{name}}가 {{time}}에 창을 닫았습니다.',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{name}}는 {{time}} 시에 사건이 완료되었다.',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{name}}는 {{time}}에 성공적으로 협업에 참여했습니다.',
	['{{name}} 已于 {{time}} 离开协作']: '{{name}}는 {{time}}에 협업을 떠났습니다.',
	['{{name}} 已于 {{time}} 中断连线']: '{{name}}는 {{time}}에 연결이 중단되었습니다.',
	['英文']: '영어',
	['验证码设定']: '验证码设定在韩文中是 "인증 코드 설정"。',
	['启用验证码']: '인증 코드 활성화',
	['设定验证码成功']: '인증 코드 설정 성공',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: '캡차 기능이 활성화되면 고객은 고객 서비스 시스템 대기 구역에 들어가기 위해 인증을 완료해야 합니다.',
	['禁止连续发话']: '연속 메시지 전송 금지',
	['启用禁止连续发话']: '연속 발언 금지 활성화',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: '회원이 \'제한 초수\' 내에 설정된 횟수 이상으로 발언하면, 시스템이 자동으로 경고합니다.',
	['客户端限制于']: '클라이언트는 제한됩니다',
	['发话次数达到']: '발화 횟수 도달',
	['次']: '차례',
	['暂时无法发话']: '잠시 말을 할 수 없습니다',
	['储存完成']: '저장 완료',
	['发送消息过于频繁 可稍后再试']: '메시지를 너무 자주 보내고 있습니다. 잠시 후 다시 시도해 주세요.',
	['IP黑名单管理']: 'IP 블랙리스트 관리',
	['共 {{total}} 笔']: '총 {{total}} 건',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: '제 {{min}} - {{max}} 건/총 {{total}} 건',
	['顯示']: '보여주다',
	['查询IP黑名单']: 'IP 차단 목록 조회',
	['设定自动添加黑名单']: '자동 블랙리스트 추가 설정',
	['白名單管理']: '화이트리스트 관리',
	['解除时间']: '해제 시간',
	['永久封锁']: '영구 차단',
	['新增IP黑名单']: 'IP 블랙리스트 추가',
	['加入黑名单后，该IP将无法进入客服前台。']: '블랙리스트에 추가되면 해당 IP는 고객 서비스 프런트에 접근할 수 없습니다.',
	['请完成安全验证']: '보안 인증을 완료해 주세요',
	['向右滑动填充拼图']: '오른쪽으로 밀어 퍼즐 맞추기',
	['启用功能']: '기능 활성화',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: 'IP가 \'제한 시간\' 내에 설정된 \'로그인 횟수\'를 초과하여 로그인하면 시스템이 자동으로 블랙리스트에 추가됩니다.',
	['限制时间']: '제한 시간',
	['时间单位不可为空']: '시간 단위는 비워둘 수 없습니다.',
	['时间单位']: '시간 단위',
	['登入次数']: '로그인 횟수',
	['封锁时间']: '차단 시간',
	['锁的持续时间，时间到了会自动解除']: '잠금 지속 시간, 시간이 만료되면 자동으로 해제됩니다.',
	['查询IP白名单']: 'IP 화이트리스트 조회',
	['删除失败']: '삭제 실패',
	['修改失败']: '수정 실패',
	['拼图验证失败次数过多']: '퍼즐 검증 실패 횟수가 너무 많습니다.',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{name}}는 {{time}}에 협력 참여를 거부하였습니다.',
	['储存过滤模組成功']: '저장 필터 모듈 성공',
	['删除过滤模組成功']: '필터 모듈 삭제 성공',
	['解除谷歌验证成功']: '구글 인증 해제 성공',
	['确定禁用平台?']: '플랫폼을 비활성화할까요?',
	['确定启用平台?']: '플랫폼을 활성화하시겠습니까?',
	['IP管理(客户端)']: 'IP 관리(클라이언트)',
	['上传']: '업로드',
	['此栏位的时间会使用于报表的团队筛选']: '이 필드의 시간은 보고서의 팀 필터링에 사용됩니다.',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: '팀 선택: 팀 통계 시간 내 모든 고객 서비스 직원의 데이터를 필터링합니다.',
	['备注最多{{inputLimit}}个字']: '비고는 최대 {{inputLimit}}자까지 입력할 수 있습니다.',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{inviter}}는 {{time}}에 대화를 {{from}}에서 {{invitee}}로 전환했습니다.',
	['小时']: '시간',
	['日']: '일',
	['会员IP：{{ip}} 已加入前台黑名单']: '회원IP：{{ip}}가 프론트엔드 블랙리스트에 추가되었습니다.',
	['新增失败']: '추가 실패',
	['会员IP被加入黑名单']: '회원 IP가 블랙리스트에 추가되었습니다.',
	['登入/接待时间']: '로그인/접수 시간',
	['timePeriodTooltipMessage']: '기간 도구 설명 메시지',
	['平均接待时间']: '평균 대기 시간',
	['平均登入时间']: '평균 로그인 시간',
	['接待时间报表']: '접대 시간 보고서',
	['登入时间报表']: '로그인 시간 보고서',
	['未登入']: '미로그인',
	['设定报表']: '보고서 설정',
	['设定对话是否记入报表中']: '대화가 보고서에 기록될지 설정하기',
	['平均通话时长报表']: '평균 통화 시간 보고서',
	['平均通话数报表']: '평균 통화 수 보고서',
	['平均等待时间报表']: '평균 대기 시간 보고서',
	['客户满意度报表']: '고객 만족도 보고서',
	['平均回覆时间报表']: '평균 응답 시간 보고서',
	['调整原因']: '조정 이유',
	['请输入调整原因']: '조정 사유를 입력하세요',
	['调整原因不可为空']: '조정 이유는 비워둘 수 없습니다.',
	['日期时间']: '날짜와 시간',
	['操作人']: '작업자',
	['原因']: '이유',
	['更多']: '더 많아요',
	['收回']: '회수',
	['设定报表成功']: '보고서 설정 성공',
	['平均回覆时间']: '평균 응답 시간',
	['客服平均回覆时间']: '평균 고객 서비스 응답 시간',
	['客户回头率']: '고객 재구매율',
	['客户ID']: '고객 ID',
	['客服帐号']: '고객 서비스 계정',
	['小时回头率']: '시간 회전율',
	['日回头率']: '일 회전율',
	['遗漏时间']: '누락된 시간',
	['请选择遗漏时间']: '누락된 시간을 선택하세요',
	['平均遗漏时间']: '평균 누락 시간',
	['1分钟']: '1분',
	['2分钟']: '2분',
	['3分钟']: '3분',
	['4分钟']: '4분',
	['5分钟']: '5분',
	['离开时间']: '출발 시간',
	['客户回头率报表']: '고객 재방문율 보고서',
	['平台报表']: '플랫폼 보고서',
	['对话总量']: '대화 총량',
	['接待总量']: '접대 총량',
	['遗漏总量']: '누적 총량',
	['智能客服总量']: '스마트 고객 서비스 총량',
	['智能转客服总量']: '스마트 전환 고객 서비스 총량',
	['最后更新时间']: '최종 업데이트 시간',
	['客服人数']: '고객 서비스 인원',
	['在线客服总数']: '온라인 고객 서비스 총 수',
	['等待服务']: '서비스 대기',
	['正在服务']: '서비스 중',
	['智能未转客服总量']: '스마트 미전환 고객 총량',
	['使用平台']: '사용 플랫폼',
	['泰文名称']: '태국어 이름',
	['请输入泰文名称']: '태국어 이름을 입력하세요',
	['英文名称']: '영문 이름',
	['请输入英文名称']: '영어 이름을 입력하세요',
	['中文名称']: '중국어 이름',
	['请输入中文名称']: '중국어 이름을 입력하세요',
	['若无需翻译请填写中文']: '필요하지 않다면 중국어를 작성해 주세요',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: '계정의 모든 보고서 데이터가 계정과 함께 삭제됩니다. 삭제하시겠습니까?',
	['停用']: '중지',
	['停用帐号']: '정지 계정',
	['通话总数']: '통화 총수',
	['等待中人数：{{pendingConversationCount}} 人']: '대기 중인 인원 수: {{pendingConversationCount}} 명',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: '보고서가 내보내지고 있습니다. 페이지 \'보고서 다운로드\'로 가서 진행 상황을 확인하고 다운로드하세요.',
	['汇出Load Data']: '데이터 로드 외부로 내보내기',
	['报表下载']: '보고서 다운로드',
	['全平台']: '전체 플랫폼',
	['报表类型']: '보고서 유형',
	['数据范围']: '데이터 범위',
	['汇出时间']: '수출 시간',
	['完成时间']: '완료 시간',
	['申请者']: '지원자',
	['下载']: '다운로드',
	['重新汇出']: '재수출',
	['处理中']: '처리 중',
	['已完成']: '완료되었습니다',
	['失败']: '실패',
	['下载成功']: '다운로드 성공',
	['历史对话纪录']: '역사 대화 기록',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: '연결이 끊겼습니다. 확인을 눌러 재연결을 시도해 주세요...',
	['引用功能管理']: '인용 기능 관리',
	['引用对话']: '인용 대화',
	['设定引用对话成功']: '인용 대화 설정 성공',
	['客户管理']: '고객 관리',
	['重要客户帐号']: '중요 고객 계정',
	['请输入重要客户帐号、备注等关键字']: '중요 고객 계정, 비고 등 키워드를 입력하세요',
	['新增重要客户']: '중요 고객 추가',
	['重要客户帐号不能为空']: '중요 고객 계정은 비워둘 수 없습니다',
	['输入多个帐号请用, 区隔']: '여러 개의 계정을 입력할 때는 , 로 구분해주세요.',
	['修改重要客户']: '중요 고객 수정',
	['重要帐号']: '중요한 계정',
	['会员类型']: '회원 유형',
	['引用']: '인용',
	['收回(訊息)']: '회수(메시지)',
	['收回功能管理']: '기능 관리 회수',
	['收回提示文字不能为空']: '제목 텍스트는 비워둘 수 없습니다.',
	['收回对话']: '대화 회수',
	['收回提示文字（中文）']: '회수 알림 문자',
	['收回提示文字（英文）']: '수거하는 안내 문자',
	['收回提示文字（泰文）']: '주문 메시지 회수 (태국어)',
	['视频']: '비디오',
	['确定要收回讯息吗？']: '메시지를 회수하시겠습니까?',
	['设定收回功能成功']: '회수 기능 설정 성공',
	['遗漏数据']: '누락 데이터',
	['全选']: '전체 선택',
	['请选择使用平台']: '사용할 플랫폼을 선택하세요',
	['日期计算方式']: '날짜 계산 방법',
	['以会员进入正在服务区的时间计算']: '회원이 서비스 구역에 들어간 시간을 기준으로 계산',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: '회원이 대기 서비스 구역에 들어가는 시간을 기준으로 계산할 때, 스마트 고객 서비스를 클릭해 대기 서비스 구역에 들어가지 않는 경우에는 스마트 고객 서비스를 클릭한 시간을 기준으로 계산합니다.',
	['以会员进入等待服务区的时间计算']: '회원 대기 서비스 구역에 들어가는 시간을 기준으로 계산합니다.',
	['以客服接通对话的时间进行计算']: '고객 서비스 연결 대화 시간을 기준으로 계산하다',
	['以会员进入等待服务区的时间进行计算']: '회원이 대기 서비스 구역에 들어가는 시간을 기준으로 계산합니다.',
	['以会员点击智能客服的时间计算']: '회원이 클릭한 스마트 고객 서비스의 시간을 기준으로 계산합니다.',
	['相同类型才会计算回头']: '동일한 유형만 계산한 다음 돌아옵니다.',
	['登入联系离开后再次登入联系']: '로그인 연락 후 다시 로그인 연락',
	['一通对话只会触发一次回头次数']: '한 번의 대화는 한 번의 회상 횟수를 촉발합니다.',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: '동일한 회원 시간 내에 연속적으로 3회 연락 시, 앞의 두 통 대화의 고객 서비스 각각 1회 회수로 계산.',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: '매일 같은 회원이 대화 종료 후 {{hour}} 시간 이내에 다시 연락하는 유효 대화 비율',
	['未登入联系离开后再次未登入联系']: '비로그인 연락 후 다시 비로그인 연락',
	['请输入重要客户帐号']: '중요 고객 계정을 입력해 주세요',
	['开始日期']: '시작 날짜',
	['结束日期']: '종료 날짜',
	['标签名称/数量']: '태그 이름/수량',
	['暂无数据']: '데이터 없음',
	['AI客服设定']: 'AI 고객 서비스 설정',
	['AI共同设定']: 'AI 공동 설정',
	['平台AI设定']: '플랫폼 AI 설정',
	['平台 AI SKILL 设定']: '플랫폼 AI SKILL 설정',
	['指令输入说明']: '명령어 입력 설명',
	['输入文字档']: '입력 텍스트 파일',
	['不需要区分功能']: '기능을 구분할 필요가 없다',
	['套用平台']: '적용 플랫폼',
	['请输入指令']: '명령어를 입력하세요',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'AI와 회원의 대화가 <<inputNumber>> 회를 초과하면 고객 서비스 직원에게 알리셔야 합니다.',
	['指令']: '지시어',
	['AI开关']: 'AI 스위치',
	['AI客服名称']: 'AI 고객 서비스 이름',
	['AI客服名称不能为空']: 'AI 고객 서비스 이름은 비워 둘 수 없습니다.',
	['请输入AI客服名称']: 'AI 고객 서비스 이름을 입력하세요',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: 'AI 고객 서비스를 종료하시겠습니까? 종료 후에는 AI 고객 서비스를 다시 활성화할 수 없습니다.',
	['侦测到对话有异常状态，请尽快处理']: '대화 상태 이상이 감지되었습니다. 조치해 주세요.',
	['需要转接人工客服，请尽快处理']: '상담원 연결이 필요합니다. 조치해 주세요',
	['总平均通话时长']: '총 평균 통화 시간',
	['AI平均通话时长']: 'AI 평균 통화 시간',
	['人工平均通话时长']: '인공 평균 통화 시간',
	['每日总平均']: '일일 평균',
	['AI日平均']: 'AI 일 평균',
	['人工日平均']: '인공지능 일일 평균',
	['通话总量']: '통화 총량',
	['AI通话总量']: 'AI 통화 총량',
	['共同']: '공동',
	['总计']: '총계',
	['总计请勿超过{{limit}}字']: '총합 {{limit}}자를 초과하지 마세요.',
	['总平均回覆时间']: '총 평균 응답 시간',
	['AI平均回覆时间']: 'AI 평균 응답 시간',
	['人工平均回覆时间']: '인공지능 평균 응답 시간',
	['AI日总量']: 'AI 일 총량',
	['人工日总量']: '인공 일 총량',
	['指令不能为空']: '명령이 비어있을 수 없습니다.',
	['{{name}} 已于 {{time}} 开启AI']: '{{name}}는 {{time}}에 AI를 시작했습니다.',
	['{{name}} 已于 {{time}} 关闭AI']: '{{name}}는 {{time}}에 AI를 종료했습니다.',
	['人机合作日总量']: '인간-기계 협력 일일 총량',
	['人工通话总量']: '인공 통화 총량',
	['人机合作通话总量']: '인간과 기계 협업 통화 총량',
	['以对话建立时间计算']: '대화로 시간 계산하기',
	['侦测到对话有异常状态 - 对话次数超过限制']: '대화 상태 이상 감지 - 대화 횟수 초과',
	['侦测到对话有异常状态 - 系统发生错误']: '대화 상태 이상 감지 - 시스템 오류',
	['人机合作-人工日平均']: '인간-기계 협력 - 인공지능 일일 평균',
	['人机合作-AI日平均']: '인간-기계 협력 - AI 일일 평균',
	['人机合作-人工平均通话时长']: '인간-기계 협력 - 인공지능 평균 통화 시간',
	['人机合作-AI平均通话时长']: '인간-기계 협력 - AI 평균 통화 시간',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: '대화 상태 이상 감지 - AI API 대기 시간 2분 초과.',
	['侦测到对话有异常状态 - AI 发生错误']: '대화 상태 이상 감지 - AI 오류',
	['侦测到对话有异常状态 - AI 没有回复']: '대화 상태 이상 감지 - AI 응답 없음.',
	['数据']: '데이터',
	['指令不能超过{{limit}}字']: '지시어는 {{limit}}자를 초과할 수 없습니다.',
	['数据不能为空']: '데이터는 비어 있을 수 없습니다.',
	['数据不能超过100万字']: '데이터는 100만 자를 초과할 수 없습니다.',
	['需{{limit}}字以内']: '{{limit}}자 이내 필요',
	['数据输入说明']: '데이터 입력 설명',
	['需100万字以内']: '100만 자 이내 필요',
	['至少要有一组 ~~~~~ 与 =====']: '최소 한 쌍의 ~~~~~ 와 ===== 가 있어야 합니다',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: '구분 기호 ~~~~~ 와 ===== 는 쌍으로 나타나야 합니다',
	['需以 ===== 结尾']: '===== 로 끝나야 합니다',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: '제목 아래 줄에 물결표를 5개 입력하고, 앞뒤에 다른 문자나 공백이 없어야 합니다',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: '내용 아래 줄에 등호를 5개 입력하고, 앞뒤에 다른 문자나 공백이 없어야 합니다',
	['范例']: '예시',
	['标题A（可多行）']: '제목A(여러 줄 가능)',
	['内容A（可多行，可含任何文字）']: '내용A(여러 줄, 모든 문자 포함 가능)',
	['标题B（可多行）']: '제목B(여러 줄 가능)',
	['内容B（可多行，可含任何文字）']: '내용B(여러 줄, 모든 문자 포함 가능)',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: '모델 순서(위의 모델이 우선 사용되며, 실패 시 자동으로 다음 모델로 전환됩니다)',
	['主要']: '기본',
	['备援{{index}}']: '백업{{index}}',
	['新增备援模型']: '백업 모델 추가',
	['请输入数据']: '입력 데이터를 입력하세요',
	['正在转接中...']: '전환 중입니다...',
	['（中文）']: '（중국어）',
	['（英文）']: '(영어)',
	['（泰文）']: '태국어',
	['（越南文）']: '(베트남어)',
	['越南文名称']: '베트남어 명칭',
	['请输入越南文名称']: '베트남어 이름을 입력하세요',
	['模式']: '모드',
	['越南语']: '베트남어',
	['IP白名单设定']: 'IP 화이트리스트 설정',
	['建立时间']: '생성 시간',
	['批次删除']: '일괄 삭제',
	['请确认是否删除 IP 白名单？']: 'IP 화이트리스트를 삭제하시겠습니까?',
	['开启快捷选单']: '퀵 메뉴 열기',
	['收合快捷选单']: '퀵 메뉴 닫기',
	['是否有收回人员讯息']: '인원 정보가 회수되었습니까?',
	['是否有收回AI讯息']: 'AI 메시지를 회수할 수 있습니까?',
	['消息已被客服撤回']: '고객 서비스가 메시지를 철회했습니다.',
	['用户快捷选单管理']: '사용자 빠른 선택 메뉴 관리',
	['电脑预览']: '컴퓨터 미리보기',
	['手机预览']: '휴대폰 미리보기',
	['档案格式：PNG、JPG、JPEG']: '파일 형식：PNG、JPG、JPEG',
	['请选择上传档案']: '파일 업로드를 선택하세요',
	['新增快捷成功']: '단축키 추가 성공',
	['修改快捷成功']: '수정이 완료되었습니다.',
	['设定快捷选单成功']: '단축 메뉴 설정 성공',
	['删除快捷成功']: '삭제 단축키 성공',
	['确定删除此快捷？']: '이 단축키를 삭제하시겠습니까?',
	['新增内容']: '新增内容在韩文中说为 추가 내용',
	['选项內容']: '옵션 내용',
	['{{itemLabel}}內容不能为空']: '{{itemLabel}} 내용은 비워둘 수 없습니다.',
	['请输入{{itemLabel}}标题']: '{{itemLabel}} 제목을 입력하세요',
	['请输入{{itemLabel}}选项']: '{{itemLabel}} 옵션을 입력하세요',
	['{{text}}不可为空']: '{{text}}는 비워둘 수 없습니다.',
	['显示更多']: '더보기',
	['公告标签']: '공지 태그',
	['请选择公告标签']: '공지사항 태그를 선택하십시오',
	['{{text}}标题']: '{{text}} 제목',
	['{{text}}內文']: '{{text}} 내장',
	['{{text}}最多{{inputLimit}}个字']: '{{text}} 최대 {{inputLimit}}자',
	['公告内文档案大小总计不得大于10MB']: '공지 내 문서 파일 크기는 총 10MB를 초과할 수 없습니다.',
	['用户尚未离开，确认要完成对话？']: '사용자가 아직 떠나지 않았습니다. 대화를 완료하시겠습니까?',
	['{{name}} 已于 {{time}} 离开对话']: '{{name}}는 {{time}}에 대화를 떠났습니다.',
	['客服人员']: '客服人员 - 고객 서비스 직원',
	['*新增多个IP请使用逗号「 , 」隔开']: '여러 개의 IP를 추가하려면 쉼표「 , 」로 구분하십시오.',
	['是否新增IP白名单？']: 'IP 화이트리스트를 추가하겠습니까?',
	['IP已存在']: 'IP가 이미 존재합니다',
	['监控区管理']: '모니터링 구역 관리',
	['监控区开关']: '모니터링 구역 스위치',
	['设定监控区开关成功']: '모니터링 구역 스위치 설정 성공',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: '기능을 활성화하면, 대기 서비스 지역에 [모니터링 구역] 탭이 추가되어 전체 플랫폼에서 AI가 차단한 대화와 읽지 않은 시간이 가장 긴 5개의 대화를 표시하며, 클릭하면 해당 대화로 빠르게 이동할 수 있습니다.',
	['{{name}} 新增了标签 {{tag}}']: '{{name}}가 태그 {{tag}}를 추가했습니다.',
	['{{name}} 移除了标签 {{tag}}']: '{{name}} 태그 {{tag}}를 제거했습니다.',
	['状态切换为暂离']: '상태가 일시적으로 변경되었습니다.',
	['状态切换为工作中']: '상태를 작업 중으로 전환',
	['监控区']: '모니터링 구역',
	['自动接线管理']: '자동 접선 관리',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: '고객 서비스 전 플랫폼 접수 수가 한도에 도달한 후, 시스템은 대기 서비스 구역의 대화를 자동으로 연결하지 않으며, 고객 서비스 직원의 수동 연결 수에는 제한이 없습니다.',
	['自动接线数量上限']: '자동 접속 수량 한도',
	['设定自动接线成功']: '자동 접속 설정 성공',
	['{{name}} 进线']: '{{name}} 전화 연결',
	['工作/暂离时间']: '근무/휴가 시간',
	['工作时长报表']: '근무 시간 보고서',
	['暂离时长报表']: '잠시 이탈 시간 보고서',
	['平均工作时长']: '평균 근무 시간',
	['平均暂离时长']: '평균 잠시 떠나는 시간',
	['关键字提醒']: '키워드 알림',
	['客户发话']: '고객 말씀',
	['AI发话']: 'AI 발언',
	['发话来源']: '발화 출처',
	['请输入发话来源、关键字']: '발화 출처, 키워드를 입력하세요',
	['新增关键字']: '새로운 키워드 추가',
	['修改关键字']: '키워드 수정',
	['新增关键字成功']: '키워드 추가 성공',
	['修改关键字成功']: '키워드 수정 성공',
	['删除关键字成功']: '키워드 삭제 성공',
	['是否删除此关键字？']: '이 키워드를 삭제하시겠습니까?',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: '키워드를 넘기지 말고 100자 이상이 안 되게 ‘;’로 구분해 주세요.',
	['客户触发关键字 [{{word}}] 请客服人员注意']: '고객이 키워드 [{{word}}]를 트리거했습니다. 고객 서비스 직원의 주의가 필요합니다.',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AI 트리거 키워드 [{{word}}] 고객 서비스 직원이 주의하세요',
	['请输入通知时间']: '알림 시간을 입력하세요',
	['自动接线开关']: '자동 연결 스위치',
	['自动接线数量上限不可为空']: '자동 접선 수량 상한은 비어 있을 수 없습니다.',
	['请输入数量上限']: '수량 한도 입력',
	['离开状态侦测开关']: '상태 감지 스위치 끄기',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: '시작하면 고객 서비스 직원이 플랫폼의 마지막 작업 상태이거나 여전히 접대 중이며 다른 사람과의 대화에 협업하지 않을 때, 떠나는 상태로 전환할 수 없습니다.',
	['离开时间通知开关']: '출발 시간 알림 스위치',
	['通知时间不可重复']: '알림 시간은 중복될 수 없습니다.',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: '탐지 권한 CS 계정 퇴장 시간, 퇴장 시간이 설정된 시간에 도달하면 권한 매니저 이상의 계정에 통지하며, 퇴장 시간을 트리거한 CS 계정 본인에게도 알립니다.',
	['最后暂离时间报表']: '최종 일시별 보고서',
	['平均最后暂离时间']: '평균 마지막 중단 시간',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{name}} 떠난 시간은 [{{minute}}] 분이 되었습니다!',
	['历史对话记录下载']: '역사 대화 기록 다운로드',
	['使用模式']: '사용 패턴',
	['标准模式']: '표준 모드',
	['ID模式']: 'ID 모드',
	['即进模式']: '즉시 모드',
	['复制即进网址']: '복사 즉 진입 웹사이트',
	['生成新网址']: '새 웹사이트 생성',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: '고객 프로필 자료의 표준 모드를 제공해야 하며, 이 모드는 시스템 사전 설정 모드입니다.',
	['输入ID 进入客服，可不提供客戶Profile资料。']: '입력 ID를 통해 고객 서비스에 들어가면 고객 프로필 자료를 제공하지 않을 수 있습니다.',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: '즉시 접속 URL을 통해 고객 서비스 시스템에 직접 들어갈 수 있으며, 자료를 제공할 필요 없이 시스템이 자동으로 랜덤 방문자 이름을 부여합니다.',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: '다시 한 번 [<<prevTypeText>>]에서 [<<nextTypeText>>]로 전환하는지 확인해 주세요.',
	['以下是即进网址']: '아래는 즉시 진행할 웹사이트입니다',
	['复制网址']: '주소 복사',
	['使用模式切换成功']: '사용 모드 전환 성공',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: '웹사이트 변경 여부를 다시 확인해 주세요. 변경 시 <<redText>>',
	['当前即进网址']: '현재 즉진 웹사이트',
	['新即进网址']: '신즉진웹사이트',
	['复制即进网址成功']: '복사 후 사이트에 성공적으로 접속했습니다.',
	['报表统计']: '보고서 통계',
	['操作時間']: '작동 시간',
	['统计类型']: '통계 유형',
	['请选择统计类型']: '통계 유형을 선택하십시오',
	['查询参数']: '쿼리 매개변수',
	['申请时间']: '신청 시간',
	['产出时间']: '산출 시간',
	['申请帐号']: '계정 신청',
	['详细资料']: '상세 정보',
	['重新执行统计']: '재실행 통계',
	['执行统计']: '통계 실행',
	['登入时间范围']: '로그인 시간 범위',
	['选择团队：筛选出该团队所有客服人员']: '팀 선택: 해당 팀의 모든 고객 서비스 직원 필터링',
	['API接收日志']: 'API 수신 로그',
	['新增来源']: '새 출처',
	['CS']: 'CS',
	['包网']: '포장망',
	['包网API']: '패킷 API',
	['第 {{min}} - {{max}} 笔']: '제 {{min}} - {{max}} 필기',
	['选择的日期区间需小于等于{{limit}}天']: '선택한 날짜 범위는 {{limit}}일 이하여야 합니다.',
	['请选择日期时间查询条件']: '날짜와 시간 검색 조건을 선택하세요.',
	['类型']: '유형',
	['公司']: '회사',
	['请输入公司']: '회사를 입력하세요',
	['会员帐号']: '회원 계정',
	['请输入会员帐号']: '회원 계정을 입력하세요',
	['是否查看详细资料？']: '자세한 정보를 보시겠습니까?',
	['传送资料']: '전송 자료',
	['CS回覆资料']: 'CS 답변 자료',
	['内容']: '내용',
	['请选择进入的公司']: '입장할 회사를 선택하세요',
	['指令数据更新纪录']: '지시 데이터 업데이트 기록',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '1. 정렬 메커니즘: 모든 회사의 지시는 통일된 정렬 처리를 통해 시스템이 효율적으로 운영되도록 합니다.',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '2. 데이터 격리: 사용자는 자기 회사의 업데이트 기록만 볼 수 있고, 다른 회사의 기록은 볼 수 없습니다.',
	['微调训练']: '미세 조정 훈련',
	['执行微调']: '미세 조정',
	['操作帐号']: '운영 계정',
	['是否修改AI API?']: 'AI API를 수정합니까?',
	['保存设置']: '저장 설정',
	['修改AI API成功']: 'AI API 수정 성공',
	['请输入{{text}}']: '입력하세요 {{text}}',
	['{{text}}不能超过{{limit}}字元']: '{{text}}는 {{limit}}자를 초과할 수 없습니다.',
	['AI API']: 'AI API',
	['微调训练记录']: '미세 조정 훈련 기록',
	['模型名称']: '모델 이름',
	['新增文本']: '새 텍스트',
	['修改文本']: '텍스트 수정',
	['请输入名称']: '이름을 입력하세요',
	['取消修改微调文本']: '수정 미세 조정 텍스트 취소',
	['角色不可为空']: '역할은 비어있을 수 없습니다.',
	['请选择角色']: '캐릭터를 선택하세요',
	['内容不可为空']: '내용은 비워둘 수 없습니다.',
	['请输入内容']: '내용을 입력하세요',
	['系统']: '시스템',
	['会员']: '회원',
	['AI']: 'AI',
	['请确认是否取消？']: '취소하시겠습니까?',
	['新增微调文本成功']: '새로운 미세 조정 텍스트가 성공적으로 추가되었습니다.',
	['修改微调文本成功']: '텍스트 수정 성공',
	['自定模型名称']: '자체 모델 이름',
	['微调确认讯息']: '미세 조정 확인 메시지',
	['请确认是否执行微调训练？']: '미세 조정 훈련을 실행할지 확인해 주세요?',
	['删除微调文本']: '미세 조정 텍스트 삭제',
	['请确认是否刪除？']: '삭제하시겠습니까?',
	['刪除微调文本成功']: '미세 조정 텍스트 삭제 성공',
	['请输入模型名称']: '모델 이름을 입력하세요',
	['执行微调成功']: '미세 조정 성공',
	['取消修改文本成功']: '수정된 텍스트 취소 성공',
	['取消新增文本成功']: '텍스트 추가 취소가 성공했습니다.',
	['您已成功登出客服系统。']: '고객 서비스 시스템에서 성공적으로 로그아웃되었습니다.',
	['如需重新登录，请返回包网！']: '다시 로그인하려면 패키지 사이트로 돌아가세요!',
	['您已成功登出客服系统管理端。']: '고객 서비스 시스템 관리端에서 성공적으로 로그아웃되었습니다.',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: '"평균 대기 시간"이 0초로 표시될 때 가능한 원인은 다음과 같습니다：',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: '당일 모든 대화의 대기 시간은 0초입니다 (예: 자동 접수 또는 즉시 응답으로 대기할 필요 없음).',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2. 공식에 따라 「일일 총 대기 시간 ÷ 일일 대화 수」로 계산한 결과는 반올림하여 0초입니다.',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: '시스템에 「로그인하지 않음」이라고 표시될 때, 해당 계정이 설정된 팀 시간 내에 대화 데이터가 발생하지 않았음을 나타냅니다.',
	['加入微调']: '미세 조정',
	['启用API Key']: 'API 키 활성화',
	['微调汇入对话记录']: '미세 조정 대화 기록',
	['对话数量']: '대화 수',
	['文本最后角色需为AI或客服人员']: '문자 마지막 역할은 AI나 고객 지원 직원이어야 합니다.',
	['汇入微调文本']: '미세 조정 텍스트',
	['檔案格式：CSV，且档案大小不得大于']: '파일 형식: CSV이며 파일 크기는 초과하면 안 됩니다',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: '텍스트 마지막 역할은 AI 또는 고객 서비스 직원이어야 합니다. 수정한 후 다시 내보내거나 미세 조정을 진행하세요.',
	['批量加入微调']: '대량 추가 미세 조정',
	['自定加入微调的名称']: '자체 추가 미세 조정의 이름',
	['微调名称']: '미세 조정 이름',
	['请输入微调的名称']: '미세 조정 이름을 입력하세요',
	['微调的名称']: '미세 조정의 이름',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: '대량 삭제 여부를 확인하세요(총 {{selectedFineTuningRecordsLength}}건',
	['已取消']: '취소됨',
	['取消微调']: '미세 조정 취소',
	['取消微调成功']: '세밀 조정 취소 성공',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: '이 고객 서비스 시스템의 미세 조정 훈련을 취소하려면 해당 OpenAI 백엔드 미세 조정 훈련도 함께 취소해야 합니다. 두 가지 모두 취소해야만 미세 조정 훈련이 완전히 제거됩니다. 이 고객 서비스 시스템의 미세 조정 훈련을 취소하시겠습니까?',
	['复制快捷语成功']: '복사 단축어 성공',
	['复制常用图片成功']: '자주 사용하는 이미지 복사 성공',
	['左侧']: '왼쪽',
	['右侧']: '오른쪽',
	['{{text}}正在服务{{total}}则对话']: '{{text}}가 {{total}}개의 대화를 진행하고 있습니다.',
	['新增跑马灯成功']: '새로운 마르quee 추가 성공',
	['修改跑马灯成功']: '수정된 마르quee 성공',
	['刪除跑马灯成功']: '두루마리 삭제 성공',
	['启用跑马灯成功']: '모바일 러닝을 성공적으로 활성화했습니다.',
	['停用跑马灯成功']: '롤링배너 비활성화 성공',
	['对象栏位']: '대상 필드',
	['显示跑马灯内容']: '주행등 내용 표시',
	['请确认是否启用跑马灯？']: '러닝머신을 활성화할지 확인해 주세요?',
	['请确认是否停用跑马灯？']: '런닝머신을 사용 중지할지 확인해 주세요?',
	['请确认是否删除跑马灯？']: '번역 마크를 삭제하시겠습니까?',
	['{{text}}最多{{inputLimit}}组']: '{{text}} 최대 {{inputLimit}} 그룹',
	['数值范围']: '수치 범위',
	['数值不能为空']: '수치는 비어있을 수 없습니다',
	['数值']: '수치',
	['请输入数字']: '숫자를 입력하세요',
	['输入多组文字请用, 区隔']: '여러 그룹의 텍스트를 입력해 주세요, 구분 기호로 사용하세요.',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: '사용자가 대상 설정 이름 및 필드 규칙의 내용에 해당할 때만 marquee 프로모션이 활성화됩니다.',
	['新增跑马灯']: '신규 마라톤 조명',
	['对象栏位不能为空']: '대상 항목은 비워둘 수 없습니다.',
	['请输入对象栏位']: '대상 입력란을 입력해주세요',
	['栏位规则']: '열 규칙',
	['栏位规则不能为空']: '란 규칙은 비워둘 수 없습니다.',
	['请选择栏位规则']: '선택하십시오 열 규칙',
	['开头图示']: '시작 그림',
	['开头图示不能为空']: '시작 그림은 비워둘 수 없습니다.',
	['请选择开头图示']: '시작 그림을 선택하세요',
	['跑马灯内容']: '주루루 내용',
	['修改跑马灯']: '수정된 롤링 텍스트',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: '변경된 플랫폼 설정이 하위 캐릭터에 동기화 적용됩니다. 수정하시겠습니까?',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: '[개인/공용] 자주 사용하는 이미지[{{title}}]를 삭제하시겠습니까?',
	['一经确认删除无法复原。']: '삭제가 확인되면 복구할 수 없습니다.',
	['客服日志']: '고객 서비스 로그',
	['请输入内容等关键字']: '내용 입력 등 키워드',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: '[개인/공용] 단축어[{{title}}][{{content}}]를 삭제하시겠습니까?',
	['没有其他进入标签被开启，故无法关闭此进入标签']: '다른 입력 탭이 열리지 않아 이 입력 탭을 닫을 수 없습니다.',
	['没有其他进入标签被开启，故无法删除此标签']: '다른 들어가기 태그가 열리지 않아 이 태그를 삭제할 수 없습니다.',
	['所有人']: '모두',
	['自定义对象']: '사용자 정의 객체',
	['套用对象']: '적용 대상',
	['回主画面']: '홈으로 돌아가기',
	['孟加拉语']: '벵골어',
	['繁体中文']: '번체中文',
	['简体中文']: '간체중국어',
	['韩语']: '한국어',
	['日语']: '일본어',
	['葡萄牙语']: '포르투갈어',
	['印地语']: '힌디어',
	['俄语']: '러시아어',
	['重要资讯']: '중요한 정보',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: '대화 중 언어를 전환하면, 특정 상황에서 메시지 번역 기능이 약  10분 정도 지연될 수 있으며, 이로 인해 새 메시지와 오래된 메시지의 읽기에 영향을 줄 수 있습니다. 언어를 전환하시겠습니까?',
	['暂无对话']: '대화 없음',
	['档案上传中']: '파일 업로드 중',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{name}}는 {{time}}에 자동 푸시를 시작했습니다.',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{name}}는 {{time}}에 자동 푸시 알림을 종료했습니다.',
	['商户代码']: '가맹점 코드',
	['请输入商户代码']: '가맹점 코드를 입력하세요',
	['密钥']: '비밀키',
	['请输入密钥']: '비밀키를 입력하세요',
	['共同设定']: '공통 설정',
	['充值未到帐设定']: '충전 미도착 설정',
	['出款未到帐设定']: '출금 미도착 설정',
	['确认进行储存？']: '저장을 확인하시겠습니까?',
	['SKILL开关']: 'SKILL 스위치',
	['请输入SKILL']: 'SKILL을 입력하세요',
	['派单 API 参数']: '발주 API 매개변수',
	['请输入派单API URL']: '발주 API URL을 입력하세요',
	['开单者username']: '발주자 사용자명',
	['请输入开单者username']: '발주자 사용자명을 입력하세요',
	['频道名称']: '채널 이름',
	['请输入频道名称']: '채널 이름을 입력하세요',
	['开单原因']: '발주 사유',
	['请输入开单原因']: '발주 사유를 입력하세요',
	['充值订单查询 API URL']: '충전 주문 조회 API URL',
	['出款订单查询 API URL']: '출금 주문 조회 API URL',
	['同义词设定']: '동의어 설정',
	['开启BM25']: 'BM25 활성화',
	['同义词']: '동의어',
	['更新时间']: '최신 업데이트',
	['批次新增同义词']: '배치로 동의어 추가',
	['修改同义词']: '수정 동의어',
	['新增同义词']: '동의어 추가',
	['请输入同义词，使用逗号区隔不同词汇']: '동의어를 입력하세요, 각 단어는 쉼표로 구분하세요.',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: '아래 내용을 한국어로 어떻게 말하나요?',
	['输入格式说明：']: '입력 형식 설명:',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: '충전, 예치, 입금, 과금',
	['词汇与标点符号前后不要出现空白']: '단어와 구두점 앞뒤에 공백이 없어야 합니다.',
	['请用；或分行(enter)区隔同组同义词，例如：']: '부탁드립니다; 또는 엔터로 그룹 내 동의어를 구분해 주세요.',
	['充值,储值,入金,课金']: '충전',
	['log in,登入;亲,宝贝']: '로그인, 로그인; 친애하는, 귀여운',
	['请输入同义词']: '동의어를 입력하세요',
	['同义词不可为空']: '동의어는 비어 있을 수 없습니다.',
	['同义词格式有误']: '동의어 형식이 잘못되었습니다',
	['同义词不可有特殊字元']: '동의어는 특별한 문자이 없어야 한다.',
	['字元不可超过10000']: '문자는 10000자를 초과할 수 없습니다.',
	['需至少输入两个词汇']: '최소 두 개의 단어를 입력해야 합니다.',
	['删除同义词']: '동의어 삭제',
	['请确认是否删除同义词？']: '동의어를 삭제할지 확인해 주세요?',
	['新增同义词成功']: '동의어 추가 성공',
	['新增同义词失败']: '동의어 추가 실패',
	['修改同义词成功']: '동의어 수정 성공',
	['修改同义词失败']: '수정 동의어 실패',
	['删除同义词成功']: '동의어 삭제 성공',
	['删除同义词失败']: '동의어 삭제 실패',
	['内容有重复字']: '내용에 중복된 글자가 있습니다.',
	['新增图片，详细图片请参考公告管理']: '이미지 추가, 자세한 이미지는 공지 관리에서 참조해주세요.',
	['目前只支援ChatGPT进行微调训练']: '현재는 ChatGPT만 미세 조정 훈련을 지원합니다.',
	['AI系列']: 'AI 시리즈',
	['AI系列不能为空']: 'AI 시리즈는 비어 있을 수 없습니다.',
	['启用ChatGPT']: 'ChatGPT 활성화',
	['启用Gemini']: 'Gemini 활성화',
	['AI客服']: 'AI 고객 서비스',
	['ID入口']: 'ID 입구',
	['IP']: '아이피',
	['USER ID']: '사용자 ID',
	['{{itemLabel}}內容不可为空']: '{{itemLabel}} 내용은 비어 있을 수 없습니다.',
	['{{text}}仅能输入数字']: '{{text}}는 숫자만 입력할 수 있습니다.',
	['{{text}}最多{{limit}}个字元']: '{{text}} 최대 {{limit}}자',
	['{{text}}最多數字{{limit}}碼']: '{{text}} 최대 {{limit}}자리',
	['{{time}}分']: '{{time}}분',
	['{{time}}时']: '{{time}}시',
	['{{time}}秒']: '{{time}}초',
	['上一则发送后等待时间']: '이전 발송 후 대기 시간',
	['上传图片']: '이미지 업로드',
	['主要API keys']: '주요 API 키',
	['主要语言']: '주요 언어',
	['事件']: '사건',
	['以查看预览效果']: '미리보기 효과를 보기 위해',
	['依照选择模组设定UI显示位置及功能。']: '선택 모듈에 따라 UI 표시 위치 및 기능을 설정합니다.',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: '선택한 스타일에 따라 색상 조정(배경, 프레임, 색상, 선 느낌 포함).',
	['修改帐号履历成功']: '계정 이력 수정 성공',
	['修改翻译API成功']: '번역 API 수정 성공',
	['充值帐号']: '충전 계좌',
	['共 {{numOfItems}} 笔']: '총 {{numOfItems}} 건',
	['关 闭']: '닫기',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: '닫으면 전체 푸시 시스템이 작동을 중지하며, 모든 푸시 메시지는 일시적으로 무효화됩니다. 언제든지 다시 열 수 있습니다.',
	['内容最多20字元']: '내용은 20자 이내입니다',
	['内容预览']: '내용 미리보기',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: '전환 후, 마르quee 텍스트와 단축키가 명확하게 표시되지 않거나 대비가 부족할 수 있으므로 백그라운드에서 다시 설정해야 합니다.',
	['删除履历']: '이력서 삭제',
	['删除帐号履历成功']: '계정 기록 삭제가 성공적으로 이루어졌습니다.',
	['删除跑马灯']: '제거 마르다',
	['加载中...']: '로딩 중...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: '선택하면, 해당 계정이 고객 서비스에 연락할 때 계정 이름 옆에 표시됩니다.',
	['即时预览']: '즉시 미리보기',
	['取消新增微调文本']: '추가 미세 조정 텍스트 취소',
	['古典深色风格']: '고전적인 다크 스타일',
	['單次']: '단회',
	['回传表单']: '회신 양식',
	['外观风格']: '외관 스타일',
	['客户端视觉设定']: '클라이언트 비주얼 설정',
	['客户端视觉设定成功']: '클라이언트 비주얼 설정 성공',
	['尚无资料']: '아직 자료가 없습니다.',
	['展开']: '펼치다',
	['履历数量']: '이력서 수',
	['帐号履历']: '계정 이력',
	['帐号履历管理']: '계정 이력 관리',
	['平台代码不能有空白']: '플랫폼 코드에는 공백이 있어서는 안 됩니다.',
	['平台代码仅能输入英文和数字']: '플랫폼 코드는 영어와 숫자만 입력할 수 있습니다',
	['平台代码最多5码']: '플랫폼 코드 최대 5자리',
	['平台代码最少2码']: '플랫폼 코드 최소 2자리',
	['平台语言']: '플랫폼 언어',
	['平均首次工作时间']: '평균 첫 직장 시간',
	['建立者']: '제작자',
	['开关']: '스위치',
	['快速通道']: '빠른 통로',
	['手动推播']: '수동 푸시',
	['手机版']: '모바일 버전',
	['批量删除']: '일괄 삭제',
	['排序']: '정렬',
	['推播功能']: '푸시 알림 기능',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: '푸시 알림 기능 OFF: 푸시 알림 기능이 꺼지면 시스템이 작동하지 않으며, 목록에 있는 모든 전략이 무효가 됩니다.',
	['推播时间']: '푸시 알림 시간',
	['推播讯息列表']: '푸시 메시지 목록',
	['推播设定']: '푸시 알림 설정',
	['操作内容']: '작업 내용',
	['收起']: '접기',
	['数值/内容']: '수치/내용',
	['数值/内容不可为空']: '숫자/내용은 비워둘 수 없습니다.',
	['数值只能输入数字、负号、小数点']: '숫자만 입력할 수 있습니다, 부호, 소수점',
	['数值小数最多6位数']: '숫자 소수점 이하 최대 6자리',
	['数值整数最多15位']: '수치 정수는 최대 15자리입니다.',
	['新增履历']: '이력서 추가',
	['新增帐号履历成功']: '계정 이력 추가가 성공적으로 완료되었습니다.',
	['新增类型']: '추가 유형',
	['无工作']: '무직',
	['时间设定需至少为 3 分钟']: '시간 설정은 최소 3분이어야 합니다.',
	['是否修改翻译API?']: '번역 API를 수정하시겠습니까?',
	['更新成功']: '업데이트 성공',
	['更新者']: '업데이트하는 사람',
	['架构模组']: '구성 모듈',
	['栏位名称']: '열 이름',
	['栏位类型']: '열 유형',
	['栏位类型不可为空']: '열 유형은 비워 둘 수 없습니다.',
	['档案格式不符']: '파일 형식이 일치하지 않습니다.',
	['PDF文件']: 'PDF 문서',
	['模式与间隔时间']: '모드와 간격 시간',
	['欢迎回来']: '환영합니다 돌아오세요',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: '이 작업은 다른 언어로 자동 번역되며, 원본 입력 내용은 번역 결과로 덮어씌워집니다. 계속 진행할지 확인해 주세요?',
	['汇入']: '수입',
	['汇入微调文本成功']: '미세 조정 텍스트 가져오기 성공',
	['汇出微调文本成功']: '수출 미세 조정 텍스트 성공',
	['清空翻译']: '비우기',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: '모든 언어의 내용을 작성 완료해야 확인할 수 있습니다. 자동 번역으로 나머지 언어를 채울 수 있습니다.',
	['标题与内容皆需填写才可自动翻译']: '제목과 내용을 모두 입력해야 자동 번역할 수 있습니다.',
	['状态持续时间']: '상태 지속 시간',
	['用户帐号']: '사용자 계정',
	['用户帐号不能为空']: '사용자 계정은 비워둘 수 없습니다.',
	['电脑版']: '데스크톱 버전',
	['目前无适用推播']: '현재 적용 가능한 푸시 알림이 없습니다.',
	['目前有启用中的侦测语言平台，无法关闭']: '현재 사용 중인 감지 언어 플랫폼을 종료할 수 없습니다.',
	['确定删除IP白名单？']: 'IP 화이트리스트를 삭제하시겠습니까?',
	['确定发送推播？']: '푸시 알림을 전송하시겠습니까?',
	['确定要关闭推播功能吗？']: '푸시 알림 기능을 종료하시겠습니까?',
	['确认删除此笔履历?']: '이 기록을 삭제하시겠습니까?',
	['确认要删除推播讯息？']: '푸시 알림을 삭제하시겠습니까?',
	['立即登入']: '즉시 로그인',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: '제 {{min}} - {{max}} 건/총 {{numOfItems}} 건',
	['筛选条件']: '선택 조건',
	['类型名称']: '유형 이름',
	['系统预设模组']: '시스템 기본 모듈',
	['经典浅色风格']: '클래식 연한 색 스타일',
	['翻译API']: '번역 API',
	['聊天介面']: '채팅 인터페이스',
	['自动推播']: '자동 푸시',
	['自动推播功能']: '자동 푸시 기능',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: '자동 푸시 기능 OFF: 목록에 있는 모든 푸시 메시지는 여전히 고객 서비스에서 수동으로 실행할 수 있지만 모든 타이머 기능은 작동을 중지합니다.',
	['自定义']: '사용자 정의',
	['自定义文案']: '맞춤 문구',
	['自客服接起对话后开始计算']: '고객 서비스가 대화를 시작한 후 계산을 시작합니다.',
	['该类型目前有推播讯息套用中，无法删除']: '이 유형은 현재 푸시 알림이 적용 중이어서 삭제할 수 없습니다.',
	['详细说明']: '상세 설명',
	['请先选择推播类型']: '푸시 알림 유형을 먼저 선택해 주세요.',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: '일괄 삭제(총 {{selectedFineTuningRecordsLength}}건) 여부를 확인해 주시기 바랍니다.',
	['请输入事件']: '이벤트를 입력하세요',
	['请输入会员ID']: '회원 ID를 입력하세요',
	['请输入內容']: '내용을 입력하세요',
	['请输入关键字']: '키워드를 입력하세요',
	['请输入您的会员 ID 以继续']: '회원 ID를 입력하여 계속하세요.',
	['请输入数值/内容']: '수치/내용을 입력하세요',
	['请输入文字']: '텍스트를 입력하세요',
	['请输入栏位名称']: '필드 이름을 입력하세요',
	['请输入用户帐号']: '사용자 계정을 입력하세요',
	['请输入类型名称']: '유형 이름을 입력하세요',
	['请输入详细说明']: '자세한 설명을 입력하세요',
	['请选择上方下拉选单']: '상단 드롭다운 메뉴를 선택하세요.',
	['请选择主要语言自动翻译']: '주요 언어를 선택하여 자동 번역하세요',
	['请选择帐号状态']: '계정 상태를 선택하세요.',
	['请选择平台']: '플랫폼을 선택해주세요',
	['请选择推播项目']: '푸시 항목을 선택하세요',
	['请选择栏位类型']: '필드 유형을 선택하세요',
	['请选择类型']: '유형을 선택하세요',
	['请选择类型与项目(标题)以预览内容']: '유형과 항목(제목)을 선택하여 내용을 미리 보세요',
	['请选择表单选项']: '양식 옵션을 선택하십시오.',
	['请选择运算规则']: '연산 규칙을 선택하세요',
	['请选择预览画面']: '미리보기 화면을 선택하세요',
	['跑马灯设定']: '교체 문자 설정',
	['轮播']: '회전목마',
	['轮播模式']: '슬라이드 모드',
	['轮播间隔时间']: '슬라이드 간격 시간',
	['运算规则']: '운영 규칙',
	['运算规则不可为空']: '연산 규칙은 비워둘 수 없습니다.',
	['返回上一层']: '이전 단계로 돌아가기',
	['返回上一页']: '이전 페이지로 돌아가기',
	['送出推播']: '푸시 알림 보내기',
	['选单介面']: '선택 메뉴 인터페이스',
	['选择推播类型']: '푸시 알림 유형 선택',
	['选择推播项目(标题)']: '푸시 항목 선택(제목)',
	['通知时间']: '공지 시간',
	['通知时间不能为空']: '알림 시간이 비어있을 수 없습니다',
	['重新产生Key/IV']: '키/IV 재생성',
	['重要客户']: '중요 고객',
	['需为1~60正整数']: '1~60의 정수여야 합니다',
	['预估时间']: '예상 시간',
	['预览图片']: '미리보기 이미지',
	['首次工作时间报表']: '첫 번째 근무 시간 보고서',
	['日志管理']: '로그 관리',
	['API传送日志']: 'API 전송 로그',
	['订单号']: '주문 번호',
	['三方单号']: '타사 주문 번호',
	['请输入订单号']: '주문 번호를 입력하세요',
	['请输入三方单号']: '타사 주문 번호를 입력하세요',
	['充值订单查询']: '충전 주문 조회',
	['出款订单查询']: '출금 주문 조회',
	['开派单']: '배차 주문 생성',
	['传送派单信息']: '배차 정보 전송',
	['CS传送资料']: 'CS 전송 자료',
	['平台回覆资料']: '플랫폼 회신 자료',
	['{{text}}需以{{prefix}}开头']: '{{-text}}은(는) {{-prefix}}(으)로 시작해야 합니다',
	['系统通知']: '시스템 알림',
	['派单传送讯息']: '배차 메시지 전송',
	['派单传送档案']: '배차 파일 전송',
	['请输入平台']: '플랫폼을 입력해 주세요',
	['派单讯息润饰设定']: '배차 메시지 다듬기 설정',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: '이 지시는 "AI 공동 설정"과 "플랫폼 AI 설정"을 불러오지 않으며, 독립적인 Agent로 사용됩니다',
	['用户个人设定']: '사용자 개인 설정',
	['新增用户个人资讯']: '사용자 개인정보 추가',
	['个人资讯参数名称']: '개인정보 매개변수 이름',
	['请输入个人资讯参数名称']: '개인정보 매개변수 이름을 입력하세요',
	['*新增多个请使用逗号「 , 」隔开']: '*여러 개 추가하려면 쉼표「 , 」로 구분하세요',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: '이 플랫폼에서 어떤 개인정보를 AI에 전달할지 설정합니다. "사용자 개인 설정"에 설정된 매개변수만 AI로 전송됩니다',
	['批次删除用户个人资讯']: '사용자 개인정보 일괄 삭제',
	['确定要批次删除用户个人资讯吗？']: '사용자 개인정보를 일괄 삭제하시겠습니까?',
	['个人资讯参数名称不能为空']: '개인정보 매개변수 이름은 비워둘 수 없습니다',
	['已存在「{{name}}」']: '「{{-name}}」이(가) 이미 존재합니다',
	['最多可新增{{limit}}个，已超过上限']: '최대 {{-limit}}개까지 추가할 수 있으며, 상한을 초과했습니다',
	['新增用户个人资讯成功']: '사용자 개인정보 추가 성공',
	['新增用户个人资讯失败']: '사용자 개인정보 추가 실패',
	['删除用户个人资讯成功']: '사용자 개인정보 삭제 성공',
	['删除用户个人资讯失败']: '사용자 개인정보 삭제 실패',
	['图像管理']: '이미지 관리',
	['自定义图像']: '사용자 정의 이미지',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: '파일 형식: "PNG, JPG", 파일 크기는 500KB를 초과할 수 없습니다',
	['档案最大500K']: '파일 최대 500K',
	['新增图像成功']: '이미지 추가 성공',
	['删除图像成功']: '이미지 삭제 성공',
	['是否确定删除图像？']: '이미지를 삭제하시겠습니까?',
	['内容设定']: '내용 설정',
	['英语']: '영어',
	['{{language}}内容']: '{{language}} 내용',
	['请输入{{language}}内容']: '{{language}} 내용을 입력하세요',
	['请选择时间']: '시간을 선택해 주세요',
	['请选择公司']: '회사를 선택해 주세요',
	['请输入{{label}}']: '{{label}}을(를) 입력하세요',
	['原文参考（{{language}}）']: '원문 참고（{{language}}）',
	['确定清空设定吗？']: '설정을 지우시겠습니까?',
	['确定取消设定吗？']: '설정을 취소하시겠습니까?',
	['{{language}}{{tab}}']: '{{language}}{{tab}}',
	['未完成']: '미완료',
	['{{language}}{{label}}超过{{limit}}字']: '{{language}} {{label}}이(가) {{limit}}자를 초과했습니다',
	['公告标题']: '공지 제목',
	['进线IP']: '접속 IP',
	['请输入进线IP']: '접속 IP를 입력하세요',
	['模型切换：{{fromModel}} -> {{toModel}}']: '모델 전환: {{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: 'BW 백엔드에서 계정을 삭제하면 고객 서비스 시스템 계정도 동기화되어 삭제됩니다',
	['系统已有新版本，请重新整理']: '새 버전이 있습니다, 새로 고침 해주세요',
	['页面加载失败，请重试']: '페이지 로드에 실패했습니다, 다시 시도해 주세요',
	['翻译中']: '번역 중',
	['监控与即时摘要设定']: '모니터링 및 즉시 요약 설정',
	['批量转接']: '일괄 전환',
	['已选 {{count}} 则对话']: '{{count}}개 대화 선택됨',
	['勾选']: '선택',
	['全平台服务人数']: '전체 플랫폼 서비스 인원',
	['未开启{{platform}}平台']: '{{-platform}} 플랫폼이 활성화되지 않았습니다',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: '{{-inviter}}가 {{-invitee}}에게 전환에 성공했습니다. 총 {{count}}건.',
	['接受']: '수락',
	['拒绝({{seconds}}S)']: '거절({{seconds}}S)',
	['生成链接']: '링크 생성',
	['链接生成中...']: '링크 생성 중...',
	['复制链接']: '링크 복사',
	['已复制链接']: '링크가 복사되었습니다',
	['档案上传失败']: '파일 업로드 실패',
	['转档失败，请重新上传']: '변환에 실패했습니다. 다시 업로드해 주세요',
	['人工回复']: '수동 응답',
	['检视回复']: '응답 보기',
	['{{time}} AI 拦截对话']: '{{time}} AI 대화 차단',
	['AI 拦截原因与人工回复']: 'AI 차단 사유 및 수동 응답',
	['人工回复失败']: '수동 응답 실패',
	['回复讯息']: '응답 메시지',
	['对话摘要']: '대화 요약',
	['建议回复']: '추천 응답',
	['拦截原因']: '차단 사유',
	['拦截回复']: '차단된 응답',
	['确定送出']: '확인 후 전송',
	['生成链接失败']: '링크 생성에 실패했습니다',
	['连接超时，请稍后再试']: '연결 시간이 초과되었습니다. 잠시 후 다시 시도해 주세요',
	['上一则']: '이전',
	['下一则']: '다음',
	['重新传送']: '다시 전송',
	['传送中...']: '전송 중...',
	['用户端翻译失败']: '사용자 측 번역 실패',
	['重新传送失败']: '재전송 실패',
	['请确认是否删除以下模型？']: '다음 모델을 삭제하시겠습니까?',
	['新增模型']: '모델 추가',
	['请选择AI系列']: 'AI 시리즈를 선택하세요',
	['支援模型']: '지원 모델',
	['支援模型不能为空']: '지원 모델은 비워 둘 수 없습니다',
	['请选择支援模型']: '지원 모델을 선택하세요',
	['AI模型管理']: 'AI 모델 관리',
	['模型不能为空']: '모델은 비워 둘 수 없습니다',
	['请选择模型']: '모델을 선택하세요',

	['对话类型']: '대화 유형',
	['单纯AI讯息']: 'AI 메시지만',
	['单纯人员讯息']: '상담원 메시지만',
	['人员+AI讯息']: '상담원+AI 메시지',
	['是否经过AI拦截']: 'AI 차단 여부',
	['是否修改AI拦截建议回覆']: 'AI 차단 제안 답변 수정 여부',
	['监控API keys']: '모니터링 API 키',
	['管理']: '관리',

	['启用显性快取']: '명시적 캐시 활성화',
	['AI监控拦截总量']: 'AI 모니터링 차단 총량',
	['AI监控拦截']: 'AI 모니터링 차단',
	['有修改建议回覆总量']: '추천 응답 수정됨',
	['触发关键字：{{keywords}}。']: '트리거된 키워드: {{-keywords}}.',

	['版面已套用，但尚未同步至帐号']: '레이아웃이 적용되었지만 계정에 아직 동기화되지 않았습니다',
	['服务器重设失败，下次开启工作区时会再同步']: '서버 초기화에 실패했습니다. 다음에 작업 공간을 열 때 다시 동기화됩니다',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: '브라우저가 레이아웃을 저장할 수 없습니다. 나가기 전에 계정 동기화가 완료되었는지 확인하세요',

	['重设版面配置']: '레이아웃 초기화',
	['确定要将版面配置回复为系统预设吗？']: '레이아웃을 시스템 기본값으로 되돌리시겠습니까?',
	['客服支援语言']: '고객센터 지원 언어',
	['请选择支援语言']: '지원 언어를 선택해주세요',
	['请选择客服支援语言']: '고객센터 지원 언어를 선택해주세요',

	['删除平台']: '플랫폼 삭제',
	['是否确定删除{{code}}平台']: '{{-code}} 플랫폼을 삭제하시겠습니까?',
	['删除{{code}}平台成功']: '{{-code}} 플랫폼 삭제 성공',
	['上传图片或PDF']: '이미지 또는 PDF 업로드',
	['当前平台维护中，如有疑问请联系管理员']: '현재 플랫폼은 점검 중입니다. 문의 사항은 관리자에게 연락해 주세요.',
	['当前平台已禁用，如有疑问请联系管理员']: '현재 플랫폼은 비활성화되었습니다. 문의 사항은 관리자에게 연락해 주세요.',
	['收回提示文字']: '회수 안내 문구',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: '메시지를 입력하세요. 예: 죄송합니다! 잘못 보냈네요. 다시 수정해서 보내드릴게요!',
	['标签名称']: '태그 이름',
	['预览失败']: '미리보기 실패',
	['放大']: '확대',
	['缩小']: '축소',
	['上一页']: '이전 페이지',
	['下一页']: '다음 페이지',
	['点击预览']: '클릭하여 미리보기',
};
